<template>
  <div>
    <h3>{{ osName }}</h3>
    <br />
    <img
      style="height: 600px"
      :src="image"
      :alt="osName"
      @click="expandImage(image)"
    />
  </div>
</template>

<script>
export default {
  name: 'FaqBody',
  props: ['image', 'osName'],
  methods: {
    expandImage: imageUrl => {
      window.open(imageUrl, '_blank')
    },
  },
}
</script>
